var _rect, _g, _text;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUnarchiveAppBtn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 119,
    height: 35,
    viewBox: "0 0 119 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 119,
    height: 35,
    rx: 4,
    fill: "#74531b"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 6.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.015,18.5h4.752A2.529,2.529,0,0,1,22.778,19.5l.815,1.088a1.567,1.567,0,0,0,1.247.622h11.54a2.518,2.518,0,0,1,2.515,2.515V37.985A2.518,2.518,0,0,1,36.379,40.5H16.015A2.518,2.518,0,0,1,13.5,37.985V21.015A2.518,2.518,0,0,1,16.015,18.5ZM36.379,39.543a1.56,1.56,0,0,0,1.558-1.558V23.73a1.56,1.56,0,0,0-1.558-1.558H24.839a2.529,2.529,0,0,1-2.012-1.005l-.815-1.088a1.567,1.567,0,0,0-1.247-.622H16.015a1.56,1.56,0,0,0-1.558,1.558V37.985a1.56,1.56,0,0,0,1.558,1.558Z",
    transform: "translate(-13.5 -18.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.3 12.4h6.7m-3.35-3.35v6.7",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 22,
    fill: "#fff",
    fontSize: 12,
    fontFamily: "OpenSans, Open Sans"
  }, "Unarchive App")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnarchiveAppBtn);
export default __webpack_public_path__ + "static/media/unarchive_app_btn.505e6ead.svg";
export { ForwardRef as ReactComponent };